import React from "react";
import useSeatSale from "./hooks/useSeatSale";
import { Box } from "@material-ui/core";
import SeatSaleView from "./SeatSaleView";
import StepperComponent from "../../shared/StepperComponent";
import SeatsView from "./SeatsView";
import FinalizePage from "../FinalizePage";
import { RouteComponentProps } from "react-router";
import ExerciseSaleTicket from "../ExerciseSale/ExerciseSaleTicket";
import getId from "../../utils/getId";

const lengthStepper = 3;
const container = { padding: "2%", minHeight: "70vh", width: "95%", overflow: "hidden" };
declare const config: { EXERCISE_IDS_MANY_TICKET: string };

const SeatSale: React.FC<RouteComponentProps> = props => {
  const {
    loading,
    date,
    setDate,
    exerciseList,
    ticketList,
    zoneScheme,
    handleClickSeat,
    onClickPlanSeat,
    openTicketModal,
    setOpenTicketModal,
    getZoneScheme,
    exercise,
    activeStep,
    setActiveStep,
    setTicketList,
    setZoneScheme,
    addTicket
  } = useSeatSale(props);

  const steps = [
    {
      label: "Wybór imprezy",
      component: (
        <SeatSaleView
          loading={loading}
          date={date}
          exerciseList={exerciseList}
          setDate={setDate}
          activeStep={activeStep}
          setActiveStep={setActiveStep}
          getTicket={onClickPlanSeat}
        />
      )
    },
    ...(getId(exercise) === config.EXERCISE_IDS_MANY_TICKET
      ? [
          {
            label: "Wybór biletów",
            component: (
              <ExerciseSaleTicket
                activeStep={activeStep}
                lengthStepper={lengthStepper}
                setActiveStep={(value: number) => {
                  if (activeStep === 0) {
                    setTicketList([]);
                  }
                  setActiveStep(value);
                }}
                loading={loading}
                ticketList={[{ tickets: ticketList }]}
                addTicket={addTicket}
              />
            )
          }
        ]
      : [
          {
            label: "Wybór biletów i miejsc",
            component: (
              <SeatsView
                loading={loading}
                ticketList={ticketList}
                zoneScheme={zoneScheme}
                handleClickSeat={handleClickSeat}
                activeStep={activeStep}
                setActiveStep={(value: number) => {
                  setZoneScheme(null);
                  setActiveStep(value);
                }}
                openTicketModal={openTicketModal}
                onCloseTicketModal={() => setOpenTicketModal(false)}
                refreshPlanSeat={getZoneScheme}
                exercise={exercise}
              />
            )
          }
        ]),
    {
      label: "Finalizacja",
      component: (
        <FinalizePage
          {...props}
          action={"pay"}
        />
      )
    }
  ];

  return (
    <Box style={container}>
      <StepperComponent steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} />
    </Box>
  );
};

export default SeatSale;
